import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal } from "react-bootstrap";
import useStateRef from 'react-usestateref';
import { Link,useNavigate } from "react-router-dom";
import Card from "../../../../../components/Card";
import swal from 'sweetalert';
//import apiPath from "../../../../../config/apipath";
import apiService from "../../../../../provider/apiService";
import Select from 'react-select';
import "../../../../App.css";


const TableData = () => {

 
 const [SaveButtonText, setSaveButtonText] = useState("Save");
 const [NewVal, setNewVal] = useStateRef('');
  const [EditVal, setEditVal] = useStateRef(true);
  const [DeleteVal, setDeleteVal] = useStateRef('');
  const [ViewVal, setViewVal] = useStateRef('');
 
  useEffect(() => {

    
    
	
	
   if(sessionStorage.getItem("UserManagement_Action")=="Add")
   {
	    setSaveButtonText("Save");
      
     
    // document.getElementById("txtVNo").value="{Auto}";
    // document.getElementById("txtBillDate").value=(new Date()).toISOString().substring(0,10);
   
	//Clear();
   
   }
   else if(sessionStorage.getItem("UserManagement_Action")=="Edit")
   {
	   setSaveButtonText("Update");
	   Display(sessionStorage.getItem("UserManagement_GroupId"),sessionStorage.getItem("UserManagement_MenuName"),sessionStorage.getItem("UserManagement_selectGroupId"),sessionStorage.getItem("UserManagement_Department"));
   }
   else if(sessionStorage.getItem("UserManagement_Action")=="Delete")
   {
	   setSaveButtonText("Delete");
	   Display(sessionStorage.getItem("UserManagement_GroupId"),sessionStorage.getItem("UserManagement_MenuName"),sessionStorage.getItem("UserManagement_selectGroupId"),sessionStorage.getItem("UserManagement_Department"));
   }
	
   ControlSettings();

   //innitialSetValue();
   

  }, []);
  
  function innitialSetValue() {


  getLookup();
  
  }

  const [isDisabled, setisDisabled]=useState(false);

  const [show1, setShow1] = useState(false);
  const [sho, setSho] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
 
   const [TMshow1, setTMShow1] = useState(false);
   const TMhandleClose1 = () => setTMShow1(false);
  


  const [dtPaidFrom, setdtPaidFrom]=useState([]);
  const [dtPaidTo, setdtPaidTo]=useState([]);
  const [dtMetal, setdtMetal]=useState([]);
  const [dtPayMode, setdtPayMode]=useState([]);
 



  const [FromCode, setFromCode, FromCodeRef] = useStateRef();
  const [ToCode, setToCode, ToCodeRef] = useStateRef();
  const [MetalCode, setMetalCode, MetalCodeRef] = useStateRef();
  const [PayMode, setPayMode, PayModeRef] = useStateRef();
 
 
  async function Clear()
   {
        

		handleClose1();
		
   }

function val(value)
{
	value=parseFloat(value);
	if(isNaN(value)==true)
		value=0;
	else
		value=value;
	
	return value;
}



function Calc()
{
  document.getElementById("txtValue").value=parseFloat(val(document.getElementById("txtRate").value)*val(document.getElementById("txtWeight").value)).toFixed(2);

  

}

async function ControlSettings()
{

  document.getElementById("txtmenuName").disabled ='true';
  document.getElementById("txtDepartment").disabled ='true';
  
  
  if((sessionStorage.getItem("UserManagement_Action")=="Edit") || (sessionStorage.getItem("UserManagement_Action")=="Delete"))
   {
  

    

   }

 



}

async function Display(GroupId,MenuName,selectGroupId,Department){

  console.log('display',MenuName,GroupId,selectGroupId,Department)
	  try
    {
     
      let postData = {
        MenuName: MenuName,
        GroupId:GroupId,
        selectGroupId:GroupId,
        Department:Department
    }


  

    const results = await apiService.postCall("useradmin/Display",postData);
console.log('results',results);
debugger;

   if (results != "-1") {
     
	 let HeadData=results.data.Head;
   

   //getLookup();
  if (HeadData[0].length>0){
      document.getElementById("txtmenuName").value=HeadData[0][0].MenuName;
      document.getElementById("txtDepartment").value=HeadData[0][0].Department;
      setNewVal(HeadData[0][0].NewVal);
      setEditVal(HeadData[0][0].EditVal);
      setDeleteVal(HeadData[0][0].DeleteVal);
      setViewVal(HeadData[0][0].ViewVal);
  }
   else{
    document.getElementById("txtmenuName").value=MenuName;
    document.getElementById("txtDepartment").value=Department;
    setNewVal(false);
    setEditVal(false);
    setDeleteVal(false);
    setViewVal(false);
   }
     

      // document.getElementById("txtBillNo").value=HeadData[0][0].BillNo;
			// document.getElementById("txtNarration").value=HeadData[0][0].Narration;
			// document.getElementById("txtChqNo").value=HeadData[0][0].ChequeNo;
			// document.getElementById("txtRate").value=HeadData[0][0].BullionRate;
      // document.getElementById("txtValue").value=HeadData[0][0].Value;
      // document.getElementById("txtWeight").value=HeadData[0][0].Weight;
      // document.getElementById("txtChqDate").value=HeadData[0][0].ChequeDate.substring(0,10);


   }

    
    }
    catch (error) {
      console.log(error);
    }

  }


async function Save(){
	  try
		{
	
		
			
			debugger;
	
		 
		let postData = {
      
			"Action" : sessionStorage.getItem("UserManagement_Action"),
			"MenuName" : sessionStorage.getItem("UserManagement_MenuName"),
      "GroupId" : sessionStorage.getItem("UserManagement_GroupId"),
      "selectGroupId" : sessionStorage.getItem("UserManagement_selectGroupId"),
      "Department" : sessionStorage.getItem("UserManagement_Department"),
      "eBranchCode" : sessionStorage.getItem("BranchCode"),
			"NewVal": document.getElementById("NewVal").checked,
      "EditVal": document.getElementById("EditVal").checked,
      "DeleteVal": document.getElementById("DeleteVal").checked,
      "ViewVal": document.getElementById("ViewVal").checked,
      
		}
    

   const results = await apiService.postCall("useradmin/Save",postData);


  debugger;

   if (results != "-1") {

if(results.errorCode=="8888")
{


  swal({

    title: "Alert",
    text: results.data,
    icon: "info",
    button: "Ok"
    
  }).then(function () {
    
  });

  return;

}  
  if(sessionStorage.getItem("UserManagement_Action")=="Add")
   {
    swal({

      title: "Success",
      text: "Successfully Add Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }

  else if(sessionStorage.getItem("UserManagement_Action")=="Edit")
   {
    swal({

      title: "Success",
      text: "Successfully Update Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }
	 
  else if(sessionStorage.getItem("UserManagement_Action")=="Delete")
  {
   swal({

     title: "Success",
     text: "Successfully Delete Your Details!",
     icon: "success",
     button: "Ok"

   }).then(function () {
     BackToList();
   });
 
 }
	 
      }
    }
    catch (error) {
      console.log(error);
    }

  }









  async function getLookup(){
	 try {
		
		 
		 
		let postData = [];
		
    const results = await apiService.postCall("useradmin/Lookup",postData);

	 if (results != "-1") {

   
			setdtPaidFrom(results.data[0][0]);
      setdtPaidTo(results.data[1][0]);
      setdtMetal(results.data[2][0]);
      setdtPayMode(results.data[3][0]);
     
      }

    } catch (error) {
      console.log(error);
    }
}

 
  const navigate = useNavigate();
  const BackToList = () => {
    navigate('../dashboard/table/admin/usermanagement/display');
  };

  return (
    <>
    <input type="Hidden" id="txtId" />

      <Row>
        <Card>
          <Card.Header className="d-flex justify-content-between">
            <div className="header-title">
              <h4 className="card-title">User Management Screen</h4>
            </div>
          </Card.Header>
          <Card.Body>
            <div className='container'>
              <div className='container-fluid'>
                <div className='row'>
                  <div className='col-lg-6'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='container-fluid py-4 '>
                        <div className='row py-2'>
                          <div className='col-md-6'>
                            <Form.Label>Menu Name</Form.Label>
                            <Form.Control type="text" readOnly="Readonly" id="txtmenuName" placeholder="" />
                          </div>
						  
						  
						            <div className='col-md-6'>
                            <Form.Label>Department</Form.Label>
                            <Form.Control type="text" readOnly="Readonly" id="txtDepartment" placeholder="" />
                          </div>
                          </div>
                          <div className='col-md-12 py-2'>
                          <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                            <div className='row'>
                              <div className='col-md-3 mb-3'>
                                <Form.Check.Input type="checkbox" className="me-3" id='NewVal' onChange={(e) => setNewVal(e.target.checked)} checked={NewVal} />
                                <Form.Check.Label>New</Form.Check.Label>
                              </div>
                              <div className='col-md-3 mb-3'>
                                <Form.Check.Input type="checkbox" className="me-3" id='EditVal' onChange={(e) => setEditVal(e.target.checked)} checked={EditVal} />
                                <Form.Check.Label>Edit </Form.Check.Label>
                              </div>
                              <div className='col-md-3 mb-3'>
                                <Form.Check.Input type="checkbox" className="me-3" id='DeleteVal' onChange={(e) => setDeleteVal(e.target.checked)} checked={DeleteVal} />
                                <Form.Check.Label>Delete</Form.Check.Label>
                              </div>
                              <div className='col-md-3 mb-3'>
                                <Form.Check.Input type="checkbox" className="me-3" id='ViewVal' onChange={(e) => setViewVal(e.target.checked)} checked={ViewVal} />
                                <Form.Check.Label>View</Form.Check.Label>
                              </div>
                            
                            </div>
                     </div>
                     </div>
                    
                      </div>

                    </div>

                  </div>
                 
                        
    
</div>
</div>

                 
             
           
			  
			    
				
				<Modal show={TMshow1} onHide={TMhandleClose1} className=".modal-lg" >
                  <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-12" >
					</Form.Group>
					 </Modal.Body>
                 </Modal>
				
	
          
              <div className='pt-2' style={{ direction: 'rtl' }} >
                <Form.Group className="form-group">
                  <Button type="button" variant='btn btn-primary' >
                    <i className="btn-inner">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
                      </svg>
                    </i>
                    <span>Print</span>
                  </Button>{' '}
                  <Button type="button" variant="btn btn-danger" onClick={BackToList}>cancel</Button> {' '}
                  <Button type="button" variant="btn btn-primary" onClick={Save}>{SaveButtonText}</Button>
                </Form.Group>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Row >
    </>
  );
};

export default TableData;
